document.addEventListener('DOMContentLoaded', () => {
  const bookingStickyButton = document.querySelector('.booking-sticky-button')
  const body = document.body

  if (bookingStickyButton) {
    // initial check
    updateBookingButtonClass(bookingStickyButton, body)

    // observe body class changes
    let observer = new MutationObserver(mutations => {
      updateBookingButtonClass(bookingStickyButton, body)
    })

    observer.observe(body, {
      attributes: true,
      attributeFilter: ['class']
    })
  }
})

function updateBookingButtonClass(bookingStickyButton, body) {
  const mediaQuery = window.matchMedia('(max-width: 569px)')

  if (mediaQuery.matches) {
    if (body.classList.contains('window-scrolled')) {
      bookingStickyButton.classList.add('is_stuck')
    } else {
      bookingStickyButton.classList.remove('is_stuck')
    }
  }
}
